import React from 'react';
import * as PropTypes from 'prop-types';
import {convertIntoAffixedValue} from './input-logic';
import {BasicNumberInput} from './basic-number-input';

export const AffixedInput = ({
	innerRef,
	label,
	modalView,
	taskModalStyle,
	value,
	placeholder,
	disabled,
	hasError,
	onClick,
	parentKeyDown,
	onBlur,
	callback,
	affix,
}) => {
	return (
		<BasicNumberInput
			innerRef={innerRef}
			placeholder={placeholder}
			value={value}
			hasError={hasError}
			onClick={onClick}
			onBlur={onBlur}
			disabled={disabled}
			parentKeyDown={parentKeyDown}
			converterValue={value => convertIntoAffixedValue(value, null, affix)}
			callback={callback}
			label={label}
			modalView={modalView}
			taskModalStyle={taskModalStyle}
		></BasicNumberInput>
	);
};

AffixedInput.propTypes = {
	/**
	 * ref to the input
	 */
	innerRef: PropTypes.object,
	/**
	 * Information when no value has been set yet.
	 */
	placeholder: PropTypes.string,
	/**
	 * Disable the input the user can't insert a new value or edit the current one.
	 */
	disabled: PropTypes.bool,
	/**
	 * When the input is focused the current value is selected. And the cursor ready to receive text input
	 */
	onClick: PropTypes.func,
	/**
	 * On blur the input parse the value to change it to the hours format (1h 30m).
	 * If this succed then it calls the mutation from the parent, else it keep the value typed and set the input as invalid
	 */
	onBlur: PropTypes.func,
	/**
	 * Indicator to show that the input is in an invalid state
	 */
	hasError: PropTypes.bool,
	/**
	 * Action to execute if the validation is successful
	 */
	callback: PropTypes.func,
	/**
	 * Value of the input
	 */
	value: PropTypes.string,

	/**
	 * Affix to add after value (e.g. 'p' for points)
	 */
	affix: PropTypes.string,

	/**
	 * Specific styling for scheduling modal
	 */
	modalView: PropTypes.bool,

	/**
	 * Specific styling for input in task modal
	 */
	taskModalStyle: PropTypes.bool,

	/**
	 * Label attached to the input
	 */
	label: PropTypes.string,
	/**
	 * callback when pressing key, returning event and current value
	 */
	parentKeyDown: PropTypes.func,
};

AffixedInput.defaultProps = {
	disabled: false,
	hasError: false,
};
